import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets predictions for the customer's address based on their search term.
   * @returns {Promise<Object>}
   */
  async getPredictions (params) {
    Logger.info('Started getting address predictions')
    return tmxApiCall('get', '/addressPredictions', {
      params: {
        search: params.search,
        sessionToken: params.sessionToken
      }
    }
    )
  },

  /**
   * Gets details about the place the customer selected.
   * @returns {Promise<Object>}
  */
  async getPlaceDetails (params) {
    Logger.info('Started getting place details')
    return tmxApiCall('get', '/addressDetails', {
      params: {
        placeId: params.placeId,
        sessionToken: params.sessionToken
      }
    }
    )
  }
}
